// extracted by mini-css-extract-plugin
export default {"container":"KF-z"};